import { PettyCashPrintPage } from '@/features/petty-cash/pages/PettyCashPrintPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/petty-cash/$id/print')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["petty_cash.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: () => <PettyCashPrintPage />,
})
